// ============================================================
// ErrorState — Error Display Component
// ============================================================

import { Box, Typography, Button } from '@mui/material';
import { AlertCircle } from 'lucide-react';
import { tokens } from '@/theme/tokens';

export function ErrorState({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  onRetry,
  retryLabel = 'Try Again',
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: tokens.radius.full,
          backgroundColor: `${tokens.colors.error.main}10`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <AlertCircle size={32} color={tokens.colors.error.main} />
      </Box>
      <Typography variant="h6" sx={{ mb: 1, color: tokens.colors.text.primary }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: tokens.colors.text.muted, maxWidth: 400, mb: onRetry ? 3 : 0 }}
      >
        {message}
      </Typography>
      {onRetry && (
        <Button variant="outlined" onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </Box>
  );
}
